import ArrowForward from '@mui/icons-material/ArrowForward';
import { Button, Stack, Typography } from '@mui/material';
import { useNavigate } from 'react-router';
import { ContentBox } from '@/components/shared/content-box';
import { usePoliciesIndex } from '@/data/subsidy/policies';
import { formatMoney } from '@/utils/format-money';

export const PolicyRules = () => {
  const navigate = useNavigate();
  const { policy, hasOnlyOnePolicy } = usePoliciesIndex();

  const availableBalance = hasOnlyOnePolicy
    ? policy?.limits.amount_available
    : null;
  const showBalance = hasOnlyOnePolicy && availableBalance;

  return (
    <ContentBox
      py={{ sm: 0.5 }}
      direction={{ sm: 'row' }}
      gap={2}
      width={{ xs: '100%', sm: 'auto' }}
    >
      {showBalance && (
        <Stack direction="row" gap={1} alignItems="center">
          <Typography noWrap>Saldo disponível:</Typography>
          <Typography
            color="success.dark"
            fontWeight="bold"
            data-testid="refund-balance"
          >
            {formatMoney(Number(availableBalance))}
          </Typography>
        </Stack>
      )}
      <Button
        endIcon={<ArrowForward />}
        onClick={() => navigate('/meus-reembolsos/minhas-politicas')}
        sx={{ width: 'fit-content' }}
      >
        {showBalance ? 'Ver regras' : 'Ver regras de reembolso'}
      </Button>
    </ContentBox>
  );
};
